import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

function appendPixel(value) {
  return typeof value === 'number' ? value + 'px' : value;
}

function border(_ref) {
  var borderWidth = _ref.borderWidth,
      borderTopWidth = _ref.borderTopWidth,
      borderRightWidth = _ref.borderRightWidth,
      borderBottomWidth = _ref.borderBottomWidth,
      borderLeftWidth = _ref.borderLeftWidth,
      radius = _ref.radius,
      radiusTop = _ref.radiusTop,
      radiusRight = _ref.radiusRight,
      radiusBottom = _ref.radiusBottom,
      radiusLeft = _ref.radiusLeft,
      styles = _objectWithoutPropertiesLoose(_ref, ["borderWidth", "borderTopWidth", "borderRightWidth", "borderBottomWidth", "borderLeftWidth", "radius", "radiusTop", "radiusRight", "radiusBottom", "radiusLeft"]);

  if (typeof borderWidth !== 'undefined') {
    styles.borderTopWidth = appendPixel(borderWidth);
    styles.borderRightWidth = appendPixel(borderWidth);
    styles.borderBottomWidth = appendPixel(borderWidth);
    styles.borderLeftWidth = appendPixel(borderWidth);
  }

  if (typeof borderTopWidth !== 'undefined') {
    styles.borderTopWidth = appendPixel(borderTopWidth);
  }

  if (typeof borderRightWidth !== 'undefined') {
    styles.borderRightWidth = appendPixel(borderRightWidth);
  }

  if (typeof borderBottomWidth !== 'undefined') {
    styles.borderBottomWidth = appendPixel(borderBottomWidth);
  }

  if (typeof borderLeftWidth !== 'undefined') {
    styles.borderLeftWidth = appendPixel(borderLeftWidth);
  }

  if (typeof radius !== 'undefined') {
    if (radius === 'circle') {
      styles.borderRadius = '100%';
    } else if (radius === 'pill') {
      styles.borderRadius = '10em';
    } else if (radius === 'pill-left') {
      styles.borderTopLeftRadius = '10em';
      styles.borderBottomLeftRadius = '10em';
    } else if (radius === 'pill-right') {
      styles.borderTopRightRadius = '10em';
      styles.borderBottomRightRadius = '10em';
    } else {
      styles.borderTopLeftRadius = appendPixel(radius);
      styles.borderTopRightRadius = appendPixel(radius);
      styles.borderBottomRightRadius = appendPixel(radius);
      styles.borderBottomLeftRadius = appendPixel(radius);
    }
  }

  if (typeof radiusTop !== 'undefined') {
    styles.borderTopLeftRadius = appendPixel(radiusTop);
    styles.borderTopRightRadius = appendPixel(radiusTop);
  }

  if (typeof radiusRight !== 'undefined') {
    styles.borderTopRightRadius = appendPixel(radiusRight);
    styles.borderBottomRightRadius = appendPixel(radiusRight);
  }

  if (typeof radiusBottom !== 'undefined') {
    styles.borderBottomRightRadius = appendPixel(radiusBottom);
    styles.borderBottomLeftRadius = appendPixel(radiusBottom);
  }

  if (typeof radiusLeft !== 'undefined') {
    styles.borderTopLeftRadius = appendPixel(radiusLeft);
    styles.borderBottomLeftRadius = appendPixel(radiusLeft);
  }

  return styles;
}

export default border;